import { Grid, Typography } from '@mui/material';
import { ISelectableItem } from './types';
import { AudienceToggleItem } from '../../../shared/audience-toggle-item';
import { styles } from './styles';

export const SelectableItem = ({
  toggleItemsProps,
  label,
  additionalSx,
  children,
  onClick,
}: ISelectableItem) => {
  return (
    <Grid sx={[styles.container, additionalSx]} onClick={onClick}>
      <Grid sx={styles.content}>
        <AudienceToggleItem {...toggleItemsProps} />
        <Typography sx={styles.label}>{label}</Typography>
      </Grid>
      {children}
    </Grid>
  );
};
